// extracted by mini-css-extract-plugin
var _1 = "TabMenu_activeTab__f029a";
var _2 = "TabMenu_arrowLeft__8477b";
var _3 = "TabMenu_arrowRight__a9934";
var _4 = "TabMenu_content__d19e2";
var _5 = "TabMenu_contentPosition__ac741";
var _6 = "TabMenu_controls__ef74e";
var _7 = "TabMenu_grow__34d0c";
var _8 = "TabMenu_isDrawArrow__31eb0";
var _9 = "TabMenu_left__b6fb6";
var _a = "TabMenu_right__cbbd7";
var _b = "TabMenu_root__b8988";
var _c = "TabMenu_spaceBetween__0d319";
var _d = "TabMenu_tabBarExtraContentGrow__88e20";
var _e = "TabMenu_tabList__3979d";
var _f = "TabMenu_tabListWrap__951aa";
var _10 = "TabMenu_tabsGrow__b9a5d";
var _11 = "TabMenu_top__3a437";
export { _1 as "activeTab", _2 as "arrowLeft", _3 as "arrowRight", _4 as "content", _5 as "contentPosition", _6 as "controls", _7 as "grow", _8 as "isDrawArrow", _9 as "left", _a as "right", _b as "root", _c as "spaceBetween", _d as "tabBarExtraContentGrow", _e as "tabList", _f as "tabListWrap", _10 as "tabsGrow", _11 as "top" }
